module.exports = __webpack_public_path__ + "img/public/SiteIcons/adminTableDotIcon.svg?dcf342a9";